import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, Repeat, Mail, ChevronRight } from 'lucide-react';
import GivePage from './GivePage';

const OVERVIEW_BODY = `Everything we have is a gift from God. Through the generous sharing of time, talent, and treasure, our parish community is able to worship joyfully, form disciples of every age, and reach out to those in need across Ladysmith, Chemainus, and beyond.

Whatever way you choose to give — a single online donation, a monthly pre-authorized debit, or the weekly envelope you drop in the collection basket — every gift is received with deep gratitude and used faithfully in the mission of All Saints Catholic Parish.`;

const METHODS = [
  { path: '/give/online', title: 'Online Donation', desc: 'Give a one-time or recurring gift by credit card in a few clicks.', Icon: CreditCard },
  { path: '/give/automatic', title: 'Automatic Debits', desc: 'Set up pre-authorized monthly contributions directly from your bank account.', Icon: Repeat },
  { path: '/give/envelopes', title: 'Weekly Envelopes', desc: 'Registered parishioners receive numbered envelopes for weekly offerings.', Icon: Mail },
];

const GiveOverview = () => (
  <GivePage
    slug="give-overview"
    eyebrow="Support Our Parish"
    title="Give Joyfully"
    subtitle="Three simple ways to support the mission of All Saints Catholic Parish."
    contentKey="give_overview_body"
    defaultBody={OVERVIEW_BODY}
    fallbackImage="https://images.unsplash.com/photo-1519452575417-564c1401ecc0?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85"
  >
    <div className="mt-12 grid md:grid-cols-3 gap-5">
      {METHODS.map(({ path, title, desc, Icon }) => (
        <Link
          key={path}
          to={path}
          data-testid={`give-method-${path.split('/').pop()}`}
          className="group bg-white border border-[#e9e0cc] hover:border-[#3a2359] hover:shadow-sm p-6 flex flex-col"
        >
          <div className="w-11 h-11 rounded-full bg-[#f2ead6] text-[#3a2359] flex items-center justify-center mb-4 group-hover:bg-[#3a2359] group-hover:text-[#f2ead6]">
            <Icon size={20} strokeWidth={1.6} />
          </div>
          <h3 className="font-display text-xl text-[#2a1a45] mb-2 leading-tight">{title}</h3>
          <p className="text-sm text-[#5a534a] leading-relaxed mb-4 flex-1">{desc}</p>
          <span className="inline-flex items-center gap-1 text-xs font-medium text-[#3a2359] group-hover:gap-2">
            Learn more <ChevronRight size={14} />
          </span>
        </Link>
      ))}
    </div>
  </GivePage>
);

export default GiveOverview;
